import { AuthAccountContactTypeChoices, ContactType } from "@graphql/generated";
import { IOrganizationStoreState } from "@store/useOrganizationStore";
import { useEffect } from "react";
import { UseFormReset } from "react-hook-form";
import { ICompanyInformationFormData } from "../formConfig";

export const getContactByType = (
  contacts: (ContactType | null)[] | null | undefined,
  type: AuthAccountContactTypeChoices,
) => contacts?.find((item) => item?.type === type)?.value;

export const useProfileFormData = (
  selectedOrganization: IOrganizationStoreState["selectedOrganization"] | null,
  reset: UseFormReset<ICompanyInformationFormData>,
) => {
  useEffect(() => {
    if (selectedOrganization) {
      reset({
        name: selectedOrganization.name,
        shortName: selectedOrganization.shortName ?? undefined,
        industry: { node: selectedOrganization.industry },
        businessType: selectedOrganization.businessType ?? undefined,
        about: selectedOrganization.about ?? undefined,
        size: selectedOrganization.size ?? undefined,
        establishedAt: selectedOrganization.establishedAt,
        nationalNumber: selectedOrganization.nationalNumber ?? undefined,
        type: selectedOrganization.type ?? undefined,
        email: selectedOrganization.email ?? undefined,
        website: getContactByType(selectedOrganization.contacts, AuthAccountContactTypeChoices.WEBSITE) ?? undefined,
        address: getContactByType(selectedOrganization.contacts, AuthAccountContactTypeChoices.ADDRESS) ?? undefined,
        contactNumber:
          getContactByType(selectedOrganization.contacts, AuthAccountContactTypeChoices.PHONE) ?? undefined,
        city: selectedOrganization.city?.id ?? undefined,
      });
    }
  }, [selectedOrganization]);

  return { getContactByType };
};
